//React
import React, { Component } from "react";
import PropTypes from "prop-types";
//CSS
import "./inputs.scss";

function Checkbox({
	name,
	options,
	required,
	disabled,
	style,
	label,
	info,
	error,
	selected,
	noLabel,
	customClasses,
	onInput,
}) {
	const wrapperClasses = [
		"input-wrapper checkbox-group",
		error ? "error" : "valid",
		required ? "required" : "not-required",
		disabled ? "disabled" : "enabled",
		style,
		customClasses,
	];

	return (
		<div className={wrapperClasses.join(" ")}>
			{label ?? false ? <label>{label}</label> : ""}
			<div className="options-wrapper">
				{options &&
					options.map((opt, i) => {
						return (
							<label
								key={i}
								className="form-control"
							>
								<input
									type="checkbox"
									name={name}
									value={opt.value}
									required={required}
									defaultChecked={
										selected == opt ||
										(selected &&
											selected.some((el) => el.value.toString() === opt.value.toString()))
									}
									disabled={disabled}
									onChange={(e) => onInput(e)}
									data-label={opt.label}
								/>
								{noLabel ? "" : (
									<span>
										<span className="checkbox-label">{opt.label}</span>
										{opt.description && (
											<span className="checkbox-description">{opt.description}</span>
										)}
									</span>
								)}
							</label>
						);
					})}
			</div>
			{info ?? false ? <div className="input-info">{info}</div> : ""}
		</div>
	);
}

Checkbox.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	required: PropTypes.bool.isRequired,
	disabled: PropTypes.bool.isRequired,
	style: PropTypes.oneOf(["row", "list"]).isRequired,
	label: PropTypes.string,
	info: PropTypes.string,
	error: PropTypes.bool,
	selected: PropTypes.any,
	noLabel: PropTypes.bool,
	customClasses: PropTypes.string,
	onInput: PropTypes.func,
};

export default Checkbox;
